/** biome-ignore-all lint/correctness/useUniqueElementIds: <only shows once> */
import './bigLoader.css'; // Assuming you have corresponding CSS for styling

const BigLoader: React.FC = () => {
  return (
    <div id="loader-wrapper">
      <div id="loader" />
      <div className="loader-section section-left" />
      <div className="loader-section section-right" />
      <div id="loader-info" className="loader-section section-text" />
    </div>
  );
};

export default BigLoader;
